<template>
  <main>
    <ConfirmationLayout :loading="loading" :is-success="isSuccess">
      <template v-slot:success>
        <p class="statusText">{{ helpData.confirmationSuccessTitle }}</p>
        <p class="statusText">{{ helpData.confirmationSuccessText }}</p>
      </template>
      <template v-slot:error>
        <p class="statusText statusError">
          {{ helpData.confirmationErrorText }}
        </p>
      </template>
    </ConfirmationLayout>
  </main>
</template>

<script>
import ConfirmationLayout from "@/components/confirmation-layout/ConfirmationLayout.vue";
import { fetchDonationStatus } from "@/api/donation";

export default {
  name: "DonateConfirmation",
  components: { ConfirmationLayout },
  computed: {
    helpData() {
      return this.$t("help");
    },
    donationId() {
      return this.$route.query.donation_id;
    }
  },
  data() {
    return {
      loading: false,
      isSuccess: null
    };
  },
  methods: {
    async getDonationStatus() {
      this.loading = true;
      try {
        const response = await fetchDonationStatus(this.donationId);
        this.isSuccess = !!response;
      } catch (error) {
        this.isSuccess = false;
        this.errorMessage = error?.message ?? "";
      } finally {
        this.loading = false;
      }
    }
  },
  mounted() {
    this.getDonationStatus();
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/vars";

.statusText {
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  margin-bottom: 16px;
  color: $second;
}

.statusError {
  color: $danger;
}
</style>
